<section class="shop-list">
  <div class="shop-page">

    <div #shopToolbar class="shop-toolbar" [class.is-pinned]="isToolbarPinned">
      <div class="shop-toolbar-inner">
      <app-nav-header class="shop-breadcrumb">
        @if (isToolbarPinned && !isFilterSectionVisible && activeFilters.length > 0) {
          <div class="sticky-filter-summary" aria-label="מסננים פעילים">
            <button type="button" class="mobile-filter-count" (click)="scrollToFilters()">
              <mat-icon>filter_alt</mat-icon><span>{{ activeFilters.length }}</span>
            </button>
            @for (filter of activeFilters; track filter.key) {
              <button type="button" class="sticky-filter-chip" (click)="removeFilter(filter.key)" [attr.aria-label]="'הסר ' + filter.label">
                <span>{{ filter.label }}: {{ filter.value }}</span><mat-icon>close</mat-icon>
              </button>
            }
            <button type="button" class="sticky-clear-all" (click)="clearAllFilters()">נקה הכול</button>
          </div>
        }
        @if (isToolbarPinned && !isFilterSectionVisible) {
          <button type="button" class="back-to-filters" (click)="scrollToFilters()" aria-label="חזרה לאזור החיפוש">
            <mat-icon>keyboard_arrow_up</mat-icon>
            <span>חזרה לחיפוש</span>
          </button>
        }
        <app-action-bar-button class="shop-actions" [actionCallbacks]="actionCallbacks"></app-action-bar-button>
      </app-nav-header>
      </div>
    </div>
    <div class="shop-content" [class.shop-content--with-map]="showDesktopMap">
      @if (filterIsOpen) {
        <div #filterSection class="filter-section">
          <app-top-filter (callBackFunction)="searchApply()"></app-top-filter>
        </div>
      }
      <app-advertisement [advertisementType]="AdvertisementEnum.BANNER_ADV"></app-advertisement>

      <div class="results-layout" [class.results-layout--map]="showDesktopMap">
        <div class="results-list">
          <div class="results-heading">
            <div>
              <p class="results-eyebrow">SALE4ALL</p>
              <h1>מודעות שמתאימות לחיפוש שלך</h1>
            </div>
            <div class="results-heading__side">
              @if (itemsList?.length) {
                <span class="results-count">{{ itemsList.length }} תוצאות</span>
              }
              @if (isNadlan && isDesktop && mapHidden) {
                <button type="button" class="map-toggle-inline" (click)="setMapHidden(false)">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 3l-.2.1L15 5.1 9 3 3.4 4.9c-.2.1-.4.3-.4.5V20.5c0 .3.2.5.5.5l.2-.1L9 18.9l6 2.1 5.6-1.9c.2-.1.4-.3.4-.5V3.5c0-.3-.2-.5-.5-.5zM15 19l-6-2.1V5l6 2.1V19z"/></svg>
                  הצג מפה
                </button>
              }
            </div>
          </div>

          @if (isNadlan && filterbaseService.mapBbox) {
            <div class="area-banner">
              <span>מוצגות מודעות באזור שנבחר במפה</span>
              <button type="button" (click)="onMapClearArea()">הצג את כל האזורים</button>
            </div>
          }

          <app-products-container [productsList]="itemsList || []" (productsChange)="listedProducts = $event"></app-products-container>
        </div>

        @if (showDesktopMap) {
          <aside class="results-map" aria-label="מפה">
            <app-nadlan-map
              [products]="listedProducts"
              [reloadKey]="mapReloadKey"
              [areaActive]="!!filterbaseService.mapBbox"
              closeLabel="הסתר מפה"
              (searchArea)="onMapSearchArea($event)"
              (clearArea)="onMapClearArea()"
              (closed)="setMapHidden(true)"></app-nadlan-map>
          </aside>
        }
      </div>
    </div>
  </div>

  <!-- SCRUM-253: phone – map / list toggle -->
  @if (isNadlan && !isDesktop) {
    @if (showMobileMap) {
      <div class="mobile-map" role="dialog" aria-label="מפת מודעות">
        <app-nadlan-map
          [products]="listedProducts"
          [reloadKey]="mapReloadKey"
          [areaActive]="!!filterbaseService.mapBbox"
          closeLabel="לרשימה"
          (searchArea)="onMapSearchArea($event)"
          (clearArea)="onMapClearArea()"
          (closed)="toggleMobileMap()"></app-nadlan-map>
      </div>
    }
    <button type="button" class="map-fab" (click)="toggleMobileMap()">
      @if (showMobileMap) {
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/></svg>
        רשימה
      } @else {
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 3l-.2.1L15 5.1 9 3 3.4 4.9c-.2.1-.4.3-.4.5V20.5c0 .3.2.5.5.5l.2-.1L9 18.9l6 2.1 5.6-1.9c.2-.1.4-.3.4-.5V3.5c0-.3-.2-.5-.5-.5zM15 19l-6-2.1V5l6 2.1V19z"/></svg>
        מפה
      }
    </button>
  }
</section>
